export const environment = {
  production: false,
  envName: 'test',
  googleMapsKey: 'AIzaSyA26-WDibGT-E7cY5EPqmyQ6-HAMb3-ENQ',


  domainBaseUrl: "https://cdbtestv2.sdaemon.com/",
  apiBaseUrl: "https://cdbtestv2api.sdaemon.com/api/",
  fileUrl: "https://cdbtestv2api.sdaemon.com",
  apiurl: "https://cdbtestv2api.sdaemon.com/",
  posapiurl: "https://kisnastoresv2api.sdaemon.com/api/",
};

// npm run build:test

// npm run start:test